import actionTypes from 'redux/actionTypes';

const initialState = {
	reportRefreshTime: '',
	canCreateAdhocReports: true,
	canCreateScheduledReports: true
};

const reportSettingsReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case actionTypes.GET_REFRESH_TIME:
			return {
				...state,
				reportRefreshTime: ''
			};
		case actionTypes.GET_REFRESH_TIME_SUCCESS:
			return {
				...state,
				reportRefreshTime: action.payload
			};
		case actionTypes.GET_REFRESH_TIME_FAILURE:
			return {
				...state,
				reportsRefreshTimeErrorCode: action.payload
			};

		case actionTypes.USER_CAN_CREATE_REPORT_SUCCESS:
			return {
				...state,
				canCreateAdhocReports: action.payload?.canCreateAdhocReports,
				canCreateScheduledReports: action.payload?.canCreateScheduledReports
			};
		case actionTypes.USER_CAN_CREATE_REPORT_FAILURE:
			return {
				...state,
				canCreateAdhocReports: true,
				canCreateScheduledReports: true
			};
		default:
			return state;
	}
};

export default reportSettingsReducer;
